import {Component, OnInit} from '@angular/core';
import {DebugService} from "./debug.service";

@Component({
  selector: 'app-debug',
  templateUrl: './debug.component.html'
})
export class DebugComponent implements OnInit {

  /**
   * toggle for open/close the data
   */
  open: boolean = false;

  /**
   * toggle for showing the component
   */
  show: boolean = false;

  /**
   * The debugdata that should be shown
   */
  data: {[key: string]: {name: string, data: any}} = {};

  /**
   * constructor
   * @param debugService
   */
  constructor(private debugService: DebugService) {}

  /**
   * @inheritDoc
   */
  ngOnInit(): void {
    // show only local and on stage
    if(this.debugService.isDebugOn() === true) {
      this.show = true;
    }

    // get the data initally and on every update
    if(this.show === true) {
      try {
        if (window.sessionStorage?.getItem('advisor-debug-open') === '1') {
          this.open = true;
        }
      } catch (e) {

      }

      this.data = this.debugService.getItems();
      this.debugService.onUpdate.subscribe(data => this.data = data);
    }
  }

  /**
   * toggle to open/close the debugdata
   */
  toggleOpen(): void {
    this.open = !this.open;

    try {
      if (window.sessionStorage) {
        window.sessionStorage.setItem('advisor-debug-open', this.open ? '1' : '0');
      }
    } catch (e) {

    }
  }

  /**
   * Checks if a string is a url
   * @param data
   */
  isUrl(data: string): boolean {
    return typeof data === "string" && data.indexOf('http') === 0;
  }

}
